import React from 'react';
import ReactDOM from 'react-dom'; // helps us connect to html file

import App from './App';
import './index.css';

ReactDOM.render(<App />, document.getElementById('root'));